<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="part-1-unnumbered-1">
<div class="heading heading-with-title heading-without-image" id="part-1-unnumbered-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Helen</h1>
</div>
</div>
</div>
</div>
<div class="text" id="part-1-unnumbered-1-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">A</span> sliver of sunlight forces its way through the tiny gap between the blind and the window frame; it’s enough to tell me that night has given way to day.</p>
<p class="subsq">I stretch and realise I’m precariously close to the edge of the bed. I roll over and move towards the centre of the bed reaching out with my arm, searching for him, for his touch and his warmth. The coldness stills me. I allow my eyes to focus properly, and the outline of his pillow greets me. It is smooth and free of indentation suggesting no head has lain upon it. I sit up and stare at the space where he should be, wondering where he is and worrying that he is okay. Then it descends, the gloom and the anguish, for now I remember…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part-001-helen.vue?479ace8a